import React from "react";
import { FC } from "react";
import FormLabel from '@mui/joy/FormLabel';
import Typography from '@mui/joy/Typography';
import Radio, { radioClasses } from '@mui/joy/Radio';
import RadioGroup from '@mui/joy/RadioGroup';
import Sheet from '@mui/joy/Sheet';
import { useField, useFormikContext } from "formik";
import {
  CheckCircle
} from "@material-ui/icons";

export const YesNoRadio: FC = (props: any) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);
    const label = props.label;

    return (
        <>
            <Typography className="radioLabel">{label}</Typography>

            <RadioGroup
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setFieldValue(field.name, (event.target as HTMLInputElement).value);
                }}
                overlay
                sx={{
                    flexDirection: 'row',
                    gap: 2,
                    [`& .${radioClasses.checked}`]: {
                    [`& .${radioClasses.action}`]: {
                        inset: -1,
                        border: '3px solid',
                        borderColor: 'primary.500',
                    },
                    },
                    [`& .${radioClasses.radio}`]: {
                    display: 'contents',
                    '& > svg': {
                        zIndex: 2,
                        position: 'absolute',
                        top: '-8px',
                        right: '-8px',
                        bgcolor: 'background.surface',
                        borderRadius: '50%',
                    },
                    },
                }}
            >
                {['Yes', 'No'].map((value) => (
                    <Sheet
                        key={value}
                        variant="outlined"
                        sx={{
                            borderRadius: 'md',
                            boxShadow: 'sm',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            p: 2,
                            minWidth: 70
                        }}
                        >
                        <Radio id={value} value={value} checked={field.value === value} checkedIcon={<CheckCircle />} />
                        <FormLabel sx={{fontSize: '20px'}}>{value}</FormLabel>
                    </Sheet>
                ))}
            </RadioGroup>
        </>
    );
};